import React from "react";
import ArticlesList from "../ArticlesList";

import { graphql, useLazyLoadQuery } from "react-relay";

const GET_ARTICLES = graphql`
  query ArticlesDisplayQuery($categories: [ID!], $searchText: String) {
    ...ArticlesList_query
      @arguments(categories: $categories, searchText: $searchText)
  }
`;

export default function ArticlesDisplay(props) {
  const queryOptions = {
    fetchPolicy: "network-only",
  };

  const data = useLazyLoadQuery(
    GET_ARTICLES,
    {
      categories: props.categories,
      searchText: props.activeSearch,
    },
    queryOptions
  );

  return <ArticlesList articleList={[]} query={data} />;
}
